import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API()+'promocje/';

export default {

    getPromocje() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getPromocja(idPro){
        return axios({
            method: 'get',
            url: URL + idPro,
        });
    },

    getPromocjeParams(dataOd,dataDo, trasa){
        return axios({
            method: 'get',
            url: (Boolean(trasa))? URL + 'szukaj?idTr='+trasa.idTr+'&dataOd='+dataOd+'&dataDo='+dataDo:URL + 'szukaj?dataOd='+dataOd+'&dataDo='+dataDo,
        });
    },

    getPromocjeDlaKursu(idKu){
        return axios({
            method: 'get',
            url: URL + 'kurs/'+idKu,
        });
    },

    addPromocja(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editPromocja(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deletePromocja(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },


}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/promocje/PromocjeService.js